import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import { StyledButton } from './styled'

const CtaButton = ({
  text,
  url,
  buttonClass,
  removeCtaButtonLink = false,
}: {
  text: string
  url: string
  buttonClass: string
  removeCtaButtonLink?: boolean
}) => {
  return (
    <StyledButton href={removeCtaButtonLink ? '' : url} className={buttonClass}>
      <CalendarTodayOutlinedIcon />
      {text}
    </StyledButton>
  )
}

export default CtaButton
